import script from "./CategoryNavBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CategoryNavBar.vue?vue&type=script&setup=true&lang=ts"

import "./CategoryNavBar.vue?vue&type=style&index=0&id=7a1a23f6&lang=css"

const __exports__ = script;

export default __exports__